export const MODEL_TYPE = {
  0: 'map',
  1: 'auth',
  2: 'eval',
  3: 'general',
  4: 'talentrv'
};
